import { memo } from 'react';
import { Text, VStack } from '@chakra-ui/react';

const ContentParser = ({ content }) => (
  <>
    {Array.isArray(content) ? (
      <VStack w="full" align="start" gap={{ mobile: '20px', tablet: '12px' }}>
        {content.map((text, i) => (
          <ContentText key={`text-content-${i}`} text={text} />
        ))}
      </VStack>
    ) : (
      <ContentText text={content} />
    )}
  </>
);

const ContentTextComponent = ({ text }) => (
  <Text textStyle="h2" color="text.darkGray" dangerouslySetInnerHTML={{ __html: text }} />
);
const ContentText = memo(ContentTextComponent);

export default memo(ContentParser);
